module.exports = __webpack_public_path__ + "static/media/logo-asisa-white.aa19a273.svg";